"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var call_vue_1 = require("./call.vue");
exports.default = call_vue_1.default;
